import ScreeningPage from '@/pages/ScreeningPage/ScreeningPage.vue'

export default ScreeningPage
